module.exports = __webpack_public_path__ + "static/media/Workout.f45a0a55.png";